import { MiscTools } from 'features/kestrelViewer/ui/tools/MiscTools'
import { NavigationModes } from 'features/kestrelViewer/ui/tools/NavigationModes'
import { PrimaryModes } from 'features/kestrelViewer/ui/tools/PrimaryModes'
import { ViewToggles } from 'features/kestrelViewer/ui/tools/ViewToggles'
import React from 'react'
import styled from 'styled-components'

const ToolsContainer = styled.div`
  display: flex;
  justify-items: center;
  flex-direction: column;
  position: absolute;
  left: 1.5rem;
  top: 3.1rem;
  gap: 8px;

  button {
    all: unset;
  }
`

export const KestrelViewerTools: React.FC = () => {
  return (
    <ToolsContainer>
      <NavigationModes />
      <PrimaryModes />
      <ViewToggles />
      <MiscTools />
    </ToolsContainer>
  )
}
